<template>
  <div class="box online_bg">
    <div class="wrap w1200">
      <!--右侧列表-->
      <div class="w1200 onsite_b task_jihua_list">
        <h5 class="none_ts" v-if="cntData <= 0 || !lists" style="text-align: center;">
          <img src="@/assets/images/none_data.jpg" alt="">
          <h4>暂无直播</h4>
        </h5>
        <dl v-for="item in lists" v-bind:key="item.id">
          <dt>
            <span class="btn_end" v-if="item.timeStateName == '未开始'">{{item.timeStateName}}</span>
            <span class="btn_px" v-if="item.timeStateName == '直播中'">{{item.timeStateName}}</span>
            <span class="btn_end" v-if="item.timeStateName == '已结束'">{{item.timeStateName}}</span>
            <img src="@/assets/images/live_img.jpg" v-if="!item.cover || item.cover == ''" />
            <img :src="item.cover" v-if="item.cover && item.cover !== ''">
          </dt>
          <dd>
            <h3>{{item.name}}</h3>
            <p class="time_t">{{ dateFormat(new Date(item.startTime), 'yyyy-MM-dd hh:mm:ss') }} 至 {{ dateFormat(new Date(item.endTime), 'yyyy-MM-dd hh:mm:ss') }}</p>
            <a class="a_detail" @click="to('liveplayDetail', item.id)" style="cursor: pointer;">查看详情</a>
          </dd>
        </dl>
        <div class="onsite_list_bottom mtf30">
          <div v-if="cntData > 0">共<b>{{cntData}}</b>条</div>
          <div v-if="cntData > 0">
            <paginate :click-handler="clickCallback" :page-count=pages
                      :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                      :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                      :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                      :first-last-button=$global.paginationOptions.first_last_button
                      :active-class=$global.paginationOptions.active_class
                      :disabled-class=$global.paginationOptions.disabled_class
                      :first-button-text=$global.paginationOptions.first_button_text
                      :last-button-text=$global.paginationOptions.last_button_text
                      :prev-text=$global.paginationOptions.prev_text
                      :next-text=$global.paginationOptions.next_text>
            </paginate>
          </div>
        </div>
      </div>
      <!--/右侧列表-->
      <div class="clear"></div>
    </div>

  </div>
</template>
<script>
  import config from '@/config'
  import api from '@/api'
  import utils from '@/utils'
  import Paginate from 'vuejs-paginate'
  export default {
    components: { Paginate },
    data () {
      return {
        filters: {
          pageNo: 1,
          pageSize: 12,
          isPublished: '1'
        },
        lists: [],
        pages: 0,
        cntData: '',
        pool: {
          information_type: {}
        }
      }
    },
    created () {
      this.search(this.filters)
    },
    mounted () {
    },
    methods: {
      dateFormat: utils.dateFormat,
      getStatus (item) {
        var now = new Date()
        var begin = new Date(item.beginDate)
        var end = new Date(item.endDate)
        if (end < now) {
          return '培训已结束'
        } else if (begin > now) {
          return '培训未开始'
        } else {
          return '培训中'
        }
      },
      clickCallback (pageNum) {
        this.filters.pageNo = pageNum
        this.search(this.filters)
      },
      to (path, id) {
        this.$router.push({
          path: path + '/' + id
        })
      },
      search (filters) {
        api.post(config.livePlayApiPath, '/livePlayInfo/findList', filters, (r) => {
          this.lists = r.data
          this.cntData = r.cntData
          this.pages = Math.ceil(r.cntData / this.filters.pageSize)
        })
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/entrain/liveplay/list.vue